import React from 'react';
import PropTypes from 'prop-types';

import './offset.css';

const Offset = ({ currentPage, pages, update }) => {
	if(pages === 0) {
		return null;
	}
	return (
		<div className="offset">
			<span onClick={() => update(-1, currentPage, pages)} className="material-icons">keyboard_arrow_left</span>
			<span>Page {currentPage} of {pages}</span>
			<span onClick={() => update(1, currentPage, pages)} className="material-icons">keyboard_arrow_right</span>
		</div>
	);
};

Offset.propTypes = {
	currentPage: PropTypes.number.isRequired,
	pages: PropTypes.number.isRequired,
	update: PropTypes.func.isRequired,
}

export default Offset;


// WEBPACK FOOTER //
// ./src/components/common/files/filters/Offset/index.js